import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/components/pages/home/Index.vue";
import About from "@/components/pages/About.vue";
import ProductList from "@/components/pages/product/List.vue";
import ProductItem from "@/components/pages/product/Item.vue";
import PartList from "@/components/pages/part/List.vue";
import PartItem from "@/components/pages/part/Item.vue";
import Contact from "@/components/pages/Contact.vue";
import Error404 from "@/components/pages/fallback/Error404.vue";
// import UnderConstruction from "@/components/pages/fallback/UnderConstruction.vue";

Vue.use(VueRouter);
const routes = [
  {
    name: "Início",
    path: "/",
    component: Home,
  },
  {
    name: "Sobre",
    path: "/sobre",
    component: About,
  },
  {
    name: "Máquinas",
    path: "/maquinas",
    component: ProductList,
  },
  {
    name: "Máquina",
    path: "/maquinas/:item",
    component: ProductItem,
  },
  {
    name: "Peças",
    path: "/pecas",
    component: PartList,
  },
  {
    name: "Peça",
    path: "/pecas/:item",
    component: PartItem,
  },
  {
    name: "Contato",
    path: "/contato",
    component: Contact,
  },
  {
    name: "Erro 404",
    path: "/error404",
    component: Error404,
  },
  {
    path: "*",
    beforeEnter: (to, from, next) => {
      next("/error404");
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});

export default router;
